"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _mobxReact = require("mobx-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _Picture = _interopRequireDefault(require("../Picture"));
var _imageUtils = require("../../utils/image-utils");
var _styles = require("./styles");
var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _CloudinaryPictureComponent; //lodash
//components
//helpers
//styles
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var CloudinaryPictureComponent = (0, _mobxReact.observer)(_class = (_class2 = (_CloudinaryPictureComponent = /*#__PURE__*/function (_Component) {
  function CloudinaryPictureComponent(props) {
    var _this;
    _classCallCheck(this, CloudinaryPictureComponent);
    _this = _callSuper(this, CloudinaryPictureComponent, [props]);
    _initializerDefineProperty(_this, "measuredContainerAspectRatio", _descriptor, _this);
    _initializerDefineProperty(_this, "measuredImageAspectRatio", _descriptor2, _this);
    _initializerDefineProperty(_this, "measuredImageOriginalSrc", _descriptor3, _this);
    _initializerDefineProperty(_this, "setMeasuredImageAspectRatio", _descriptor4, _this);
    _initializerDefineProperty(_this, "setMeasuredImageOriginalSrc", _descriptor5, _this);
    _initializerDefineProperty(_this, "setMeasuredContainerAspectRatio", _descriptor6, _this);
    _defineProperty(_this, "handlePictureLoad", function (event) {
      var src = _this.props.src;
      var _event$target = event.target,
        naturalWidth = _event$target.naturalWidth,
        naturalHeight = _event$target.naturalHeight;
      if (src !== _this.measuredImageOriginalSrc) {
        _this.setMeasuredImageAspectRatio(naturalWidth / naturalHeight);
        _this.setMeasuredImageOriginalSrc(src);
      }
    });
    _defineProperty(_this, "handleResize", function (event) {
      var width = event.width,
        height = event.height;
      _this.setMeasuredContainerAspectRatio(width / height);
    });
    (0, _mobx.makeObservable)(_this);
    return _this;
  }
  _inherits(CloudinaryPictureComponent, _Component);
  return _createClass(CloudinaryPictureComponent, [{
    key: "containerAspectRatio",
    get: function get() {
      var aspectRatio = this.props.aspectRatio;
      return aspectRatio || this.measuredContainerAspectRatio;
    }
  }, {
    key: "imageAspectRatio",
    get: function get() {
      var metadata = this.props.metadata;
      var crop = (0, _get2["default"])(metadata, 'crop');
      if (metadata && metadata.crop) {
        return (0, _imageUtils.getImageAspectRatio)(crop, metadata.rotation);
      }
      return this.measuredImageAspectRatio;
    }
  }, {
    key: "objectPositionProps",
    get: function get() {
      var metadata = this.props.metadata;
      if (!this.containerAspectRatio || !this.imageAspectRatio) {
        return null;
      }
      var _convertFocusPointToC = (0, _imageUtils.convertFocusPointToCss)(this.containerAspectRatio, this.imageAspectRatio, metadata),
        objectPositionX = _convertFocusPointToC.kx,
        objectPositionY = _convertFocusPointToC.ky;
      return {
        objectPositionX: objectPositionX,
        objectPositionY: objectPositionY
      };
    }
  }, {
    key: "sourceProps",
    get: function get() {
      var _this$props = this.props,
        metadata = _this$props.metadata,
        src = _this$props.src;
      if (!this.containerAspectRatio) {
        return null;
      }
      return (0, _imageUtils.getImageSourceProps)(this.containerAspectRatio, this.imageAspectRatio, src, (0, _omit["default"])(metadata, 'contain'));
    }
  }, {
    key: "render",
    value: function render() {
      var aspectRatio = this.props.aspectRatio;
      var forwardedProps = (0, _omit["default"])(this.props, [].concat(_toConsumableArray(Object.keys(CloudinaryPictureComponent.propTypes)), _toConsumableArray(Object.keys(_Picture["default"].propTypes))));
      if (aspectRatio) {
        return /*#__PURE__*/_react["default"].createElement(_styles.ContainerWithConstantAspectRatio, forwardedProps, this.renderPicture({
          shouldBeAbsolutelyPositioned: true
        }), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            paddingTop: "".concat(100 / aspectRatio, "%")
          }
        }));
      }
      return /*#__PURE__*/_react["default"].createElement(_styles.ContainerWithVariableAspectRatio, _extends({
        onResize: this.handleResize
      }, forwardedProps), this.renderPicture());
    }
  }, {
    key: "renderPicture",
    value: function renderPicture() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$shouldBeAbsolute = _ref.shouldBeAbsolutelyPositioned,
        shouldBeAbsolutelyPositioned = _ref$shouldBeAbsolute === void 0 ? false : _ref$shouldBeAbsolute;
      var _this$props2 = this.props,
        emptyIcon = _this$props2.emptyIcon,
        metadata = _this$props2.metadata,
        restartAnimation = _this$props2.restartAnimation,
        shouldShowSpinnerWhileLoading = _this$props2.shouldShowSpinnerWhileLoading,
        shouldShowAnimationWhileLoading = _this$props2.shouldShowAnimationWhileLoading,
        shouldShowOverlayShapes = _this$props2.shouldShowOverlayShapes,
        sizes = _this$props2.sizes,
        loadingImageCard = _this$props2.loadingImageCard;
      var objectFit = (0, _get2["default"])(metadata, 'contain') ? 'contain' : 'cover';
      var backgroundColor = objectFit === 'contain' ? (0, _get2["default"])(metadata, 'backgroundColor', '#FFF') : undefined;
      var overlayShapes = (0, _get2["default"])((0, _mobx.toJS)(metadata), 'overlays');
      return /*#__PURE__*/_react["default"].createElement(_styles.StyledPicture, _extends({
        backgroundColor: backgroundColor,
        emptyIcon: !loadingImageCard && emptyIcon,
        objectFit: objectFit,
        metadata: metadata,
        onLoad: this.handlePictureLoad,
        restartAnimation: restartAnimation,
        shouldBeAbsolutelyPositioned: shouldBeAbsolutelyPositioned,
        shouldShowSpinnerWhileLoading: shouldShowSpinnerWhileLoading,
        shouldShowAnimationWhileLoading: shouldShowAnimationWhileLoading,
        shouldShowOverlayShapes: overlayShapes && shouldShowOverlayShapes,
        overlayShapes: overlayShapes,
        sizes: sizes
      }, this.objectPositionProps, this.sourceProps));
    }
  }]);
}(_react.Component), _defineProperty(_CloudinaryPictureComponent, "defaultProps", {
  sizes: '400px'
}), _defineProperty(_CloudinaryPictureComponent, "propTypes", {
  aspectRatio: _propTypes["default"].number,
  metadata: _propTypes["default"].object
}), _CloudinaryPictureComponent), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "measuredContainerAspectRatio", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "measuredImageAspectRatio", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "measuredImageOriginalSrc", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "containerAspectRatio", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "containerAspectRatio"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "imageAspectRatio", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "imageAspectRatio"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "objectPositionProps", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "objectPositionProps"), _class2.prototype), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "setMeasuredImageAspectRatio", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;
    return function (value) {
      _this2.measuredImageAspectRatio = value;
    };
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "setMeasuredImageOriginalSrc", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;
    return function (value) {
      _this3.measuredImageOriginalSrc = value;
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "setMeasuredContainerAspectRatio", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;
    return function (value) {
      _this4.measuredContainerAspectRatio = value;
    };
  }
})), _class2)) || _class;
var _default = exports["default"] = CloudinaryPictureComponent;
//# sourceMappingURL=index.js.map